{
  "cancel": "Annuleren",
  "delete": "Verwijderen",
  "close": "Sluiten",
  "done": "Klaar",
  "deleteTitle": "Record verwijderen?",
  "deleteText": "Dit record permanent verwijderen?",
  "info": "Info",
  "objectInfoTitle": "Recordinformatie",
  "createdBy": "Aangemaakt door",
  "createdAt": "Aangemaakt op",
  "lastEditedBy": "Laatst bewerkt door",
  "editedAt": "Bewerkt op",
  "unknown": "Onbekend",
  "system": "Systeem",
  "objectHistoryTitle": "Gegevens & historie",
  "changes": "Wijzigingen",
  "loadingHistory": "Historie laden…",
  "noHistory": "Nog geen wijzigingsgeschiedenis.",
  "historyLoadError": "Historie kon niet worden geladen.",
  "someone": "Iemand",
  "historyDate": "Datum",
  "historyUser": "Gebruiker",
  "historyChange": "Wijziging",
  "actionCreated": "aangemaakt",
  "actionDeleted": "verwijderd",
  "actionChanged": "gewijzigd",
  "historyFallbackWithTitle": "“{{title}}” {{verb}}",
  "historyFallback": "Invoer {{verb}}",
  "updateAvailable": "Update beschikbaar",
  "updateBody": "Er is een nieuwe versie van deze app beschikbaar.\nEen update is vereist voor de best mogelijke ervaring.",
  "updateLater": "Later updaten",
  "updateNow": "Bijwerken",
  "internetRequired": "(Internet vereist)",
  "releaseInfo": "Releasenotities",
  "selectMandant": "Tenant selecteren",
  "noLicence": "Geen licentie beschikbaar",
  "noCompanyAssigned": "U bent niet toegewezen aan een bedrijf.",
  "companiesLoadError": "Bedrijven konden niet worden geladen",
  "logout": "Afmelden"
}
